
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quiz/burnout",
      function () {
        return require("private-next-pages/quiz/burnout.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quiz/burnout"])
      });
    }
  